import React, { Fragment } from 'react';
import { Calendar } from 'react-date-range';
import theme from 'theme';
import PropTypes from 'prop-types';
import Button from '../Button';

const DISPLAY_DATE_FORMAT = 'MM/dd/yy';

const CalendarPicker = ({ classes, initialDate, dateFormat, buttonLabel, onDateChange, onUpdateClicked }) => {
  const [date, setDate] = React.useState(initialDate);

  const handleOnChange = (date) => {
    setDate(date);
    onDateChange(date);
  };

  const handleOnUpdate = () => {
    onUpdateClicked(date);
  };

  return (
    <Fragment>
      <div className={classes.calendarWrapper}>
        <Calendar
          color={theme.color.black}
          onChange={handleOnChange}
          className={classes.calendar}
          date={date}
          dateDisplayFormat={dateFormat}
        />
      </div>
      <div className={classes.footer}>
        <Button disabled={!date} label={buttonLabel} className={classes.calendarButton} onClick={handleOnUpdate} />
      </div>
    </Fragment>
  );
};

CalendarPicker.propTypes = {
  buttonLabel: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  dateFormat: PropTypes.string,
  initialDate: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func,
  onUpdateClicked: PropTypes.func.isRequired,
};

CalendarPicker.defaultProps = {
  buttonLabel: 'update',
  classes: {},
  dateFormat: DISPLAY_DATE_FORMAT,
  initialDate: null,
  onDateChange: () => {},
};

export default CalendarPicker;
